module.exports = __webpack_public_path__ + "static/img/lj_pic1.ea164d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/nav/lj_pic1.jpg
// module id = 35UB
// module chunks = 37